import { Component, ComponentChild, h } from 'preact'
import axios from 'axios'
import { FeaturedSidebar, FeaturedTopicData } from './featuredSidebar'
import FeaturedBanner from './featuredBanner'
import { GetServerSideProps } from '../../server-middleware/context'
import { z } from 'zod'
import classnames from 'classnames'

interface WidgetComponents {
  featuredSide: ComponentChild
  featuredBanner: ComponentChild
}

type widgetTypes = 'featuredBanner' | 'featuredSide'

const showWidget = (widget: widgetTypes, data: FeaturedTopicData[]): ComponentChild => {
  const widgetComponents: WidgetComponents = {
    featuredSide: <FeaturedSidebar data={data} />,
    featuredBanner: <FeaturedBanner data={data} />
  }

  return widgetComponents[widget]
}

interface Props {
  widget: widgetTypes
}

interface State {
  data: FeaturedTopicData[]
}

export const widgetName = 'announcement_card' as const

export const config = z.unknown()

export const getServerSideProps: GetServerSideProps<unknown, Props> = async (_context, _config) => {
  return {
    widget: 'featuredSide'
  }
}

class FeaturedTopicsWrapper extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      data: []
    }
  }

  async componentDidMount() {
    const res = await axios.get(`/widget/${this.props.widget}`)
    this.setState({ data: res.data })
  }

  render() {
    const { widget } = this.props
    const { data } = this.state
    if (!data.length) {
      return null
    }
    return (
      <div className={classnames('widget--notification', 'qa-widget-notification', 'custom-notification')}>
        <div className={widget}>{showWidget(widget, data)}</div>
      </div>
    )
  }
}

export default FeaturedTopicsWrapper
